export const pageDefault = {
  pageNumber: 1,
  hasMoreItems: false,
  isFilteredByGroup: false,
  filteredByTab: undefined,
  isFetching: false,
}

const setPageNumber = (state, value) => ({ ...state, pageNumber: value })

const setHasMoreItems = (state, value) => ({ ...state, hasMoreItems: value })

const setIsFilteredByGroup = (state, value) => ({
  ...state,
  isFilteredByGroup: value,
})

const setFilteredByTab = (state, value) => ({
  ...state,
  filteredByTab: value,
})

const setFilteredByPortfolio = (state, value) => ({
  ...state,
  filteredByPortfolio: value,
})

const setIsFetching = (state, value) => ({ ...state, isFetching: value })

const setClearPage = () => ({
  ...pageDefault,
})

const pageActions = {
  PAGE_NUMBER: setPageNumber,
  HAS_MORE_ITEMS: setHasMoreItems,
  IS_FILTERED_BY_GROUP: setIsFilteredByGroup,
  SET_FILTERED_BY_TAB: setFilteredByTab,
  SET_FILTERED_BY_PORTFOLIO: setFilteredByPortfolio,
  IS_FETCHING: setIsFetching,
  CLEAR_PAGE: setClearPage,
}

const pageReducer = (state, action) => {
  return pageActions[action.type](state, action.value)
}

export default pageReducer
